export default __webpack_public_path__ + "static/portfolio-23-042d8020c86f434c9ed184f5afab1264.jpg";